import { Button, CircularProgress } from "@mui/material";
import React from "react";  
import { Link } from "react-router-dom";
import ROUTE_PATHS from "../../../utils/routePaths";
import "../CSS/CreateFlightPlan.css";
import NavigationBar from "../../../components/element/NavigationBar";

const CreateFlightPlanHeader = ({
  isValid,
  onClickBack,
  onClickSave,
  isLoading,
}) => {
  return (
    <div>
      <NavigationBar />
    
      <header className="create-flight-plan-header">
        <div className="create-flight-plan-header-bar-container">
          <div className="create-flight-plan-header-bar">
            <div className="create-flight-plan-left">
              <div className="navigation-header">
                <Link
                  to={ROUTE_PATHS.FBO_HOME}
                  className="navigation-header-link"
                >
                  Home/
                </Link>
                <Link
                  to={ROUTE_PATHS.LANDING_FEE_HOME}
                  className="navigation-header-link"
                >
                  Landing Fee/
                </Link>
                <Link
                  to={ROUTE_PATHS.LANDING_FEE_DATA}
                  className="navigation-header-link"
                >
                  View Data/
                </Link>
                Add Flight Roster
              </div>
            </div>
            <p className="create-flight-plan-center">Add Flight Roster</p>
            <div className="create-flight-plan-right">
              <Button
                variant="contained"
                className="cancel"
                onClick={onClickBack}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={isValid ? onClickSave : null}
                disabled={!isValid}
              >
                {isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default CreateFlightPlanHeader;
